import { useMemo } from 'react';
import { QueryContainer } from '@opensearch-project/opensearch/api/_types/_common.query_dsl';

import { InitialProductQueryFilters } from '@/constants';

import { useOpenSearchContext } from './useOpenSearchContext';
import { buildQueryFilterFromSearchParams } from '../utils';
import { useQueryFilterBuilders } from './query_builders';
import { useUpdateSearchParams } from './useUpdateSearchParams';

const useBooleanRefinement = ({ attribute }: { attribute: string }) => {
  const { updateQueryFiltersByFacets, queryFiltersByFacets, isLoading } =
    useOpenSearchContext();
  const { updateSearchParams } = useUpdateSearchParams();
  const { buildFacetQueryFilters } = useQueryFilterBuilders();

  const effectiveQueryFilters = useMemo(
    () => ({
      ...buildQueryFilterFromSearchParams(InitialProductQueryFilters),
      ...queryFiltersByFacets,
    }),
    [queryFiltersByFacets],
  );

  const refinedValue = useMemo(
    () =>
      (
        (effectiveQueryFilters[attribute] as QueryContainer)?.bool
          ?.should as QueryContainer[]
      )?.[0]?.match?.[attribute],
    [effectiveQueryFilters, attribute],
  );
  const isActive = useMemo(() => !!refinedValue, [refinedValue]);

  const handleRefine = () => {
    const newRefined = refinedValue ? [] : [true];
    updateSearchParams({
      [attribute]: Array.from(newRefined).map(String),
      page: '1',
    });

    updateQueryFiltersByFacets((prev: Record<string, QueryContainer>) => ({
      ...prev,
      [attribute]: buildFacetQueryFilters(attribute, newRefined),
    }));
  };

  return {
    isActive,
    refine: handleRefine,
    isLoading,
  };
};

export { useBooleanRefinement };
